import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion';
import { isEmpty } from 'lodash';

import { icon_arrow_right, icon_chevron_down, icon_chevron_up } from '@gn-audio/icons';

import { getSharedArray, getSharedLink, getTitle } from '../../../getters';
import { TitledSitecoreItem } from '../../../types';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { MajorLink, MajorLinksCategory } from '../MegaMenuTypes';
import { MobileMajorSublink } from './MobileMajorSublink';

type MajorLinksCategoryMobileComponentProps = {
  category: MajorLinksCategory;
};

const isDirectLink = (item: TitledSitecoreItem<MajorLink>) => {
  const sublinks = getSharedArray(item.fields, 'MajorSublinks') || [];
  return isEmpty(sublinks);
};

export const MobileMajorLinksCategory = ({
  category,
}: MajorLinksCategoryMobileComponentProps): JSX.Element => {
  const majorLinks = getSharedArray(category.fields, 'MajorLinks');

  const handleNavigation = (item: TitledSitecoreItem<MajorLink>) => {
    const hrefLink = getSharedLink(item.fields, 'Link');
    if (hrefLink?.value.href) {
      // replace to router.push after coexistence period.
      window.location.href = hrefLink.value.href;
    }
  };

  const handleMajorlinkClick = (item: TitledSitecoreItem<MajorLink>) => {
    const sublinks = getSharedArray(item.fields, 'MajorSublinks') || [];
    const hrefLink = getSharedLink(item.fields, 'Link');
    if (isEmpty(sublinks) && hrefLink?.value.href) {
      // replace to router.push after coexistence period.
      window.location.href = hrefLink.value.href;
    }
  };
  return (
    <div className="flex min-w-fit lg:pr-4">
      <div className="my-4 block w-full lg:hidden">
        <Accordion
          className="AccordionRoot flex flex-col gap-3"
          type="single"
          defaultValue="item-1"
          collapsible
        >
          {majorLinks.map((majorLink) => {
            const title = getTitle(majorLink) || majorLink.displayName;
            const sublinks = getSharedArray(majorLink.fields, 'MajorSublinks') ?? [];
            const linkField = getSharedLink(majorLink.fields, 'Link');

            const isDirect = isDirectLink(majorLink);
            if (isDirect && linkField) {
              return (
                <a
                  key={majorLink.id}
                  href={linkField?.value?.href}
                  className="flex items-center justify-between px-5 py-2 font-semibold leading-6"
                >
                  {title}
                  <JabraIcon className="h-4" Icon={icon_arrow_right} />
                </a>
              );
            }
            if (isDirect && !linkField) {
              return null;
            }
            return (
              <AccordionItem value={majorLink.id} key={majorLink.id}>
                <AccordionTrigger
                  className="group flex w-full items-center justify-between px-5 py-2"
                  onClick={() => handleMajorlinkClick(majorLink)}
                >
                  <span className="font-semibold leading-6">{title}</span>
                  {!isDirect && (
                    <>
                      <JabraIcon
                        className="h-3 w-3 group-data-[state=open]:hidden"
                        Icon={icon_chevron_down}
                      />
                      <JabraIcon
                        className="h-3 w-3 group-data-[state=closed]:hidden"
                        Icon={icon_chevron_up}
                      />
                    </>
                  )}
                </AccordionTrigger>
                <AccordionContent className="collapsible-content bg-gray-50 px-5">
                  {sublinks.map((sublink, index) => {
                    return (
                      <MobileMajorSublink
                        key={sublink.id}
                        sublink={sublink}
                        isLast={index === sublinks.length - 1}
                        handleNavigation={handleNavigation}
                      />
                    );
                  })}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};
